import HeroSection from './HeroSection/WarrantyHeroSection';
import AboutSection from './AboutSection/WarrantyAboutSection';
import ListSection from './ListSection/WarrantyListSection';
import HighlightSection from './HighlightSection/WarrantyHighlightSection';
import '../../../assets/styles/main.scss';

const WarrantyPage = ({ fields }) => {
  // 安全的字段提取函数
  const getFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 从Sitecore fields中提取warranty数据
  const {
    heroImage,
    heroText,
    aboutDurationValue,
    aboutMileageValue,
    aboutDurationUnit,
    aboutMileageUnit,
    aboutButtonUrl,
    aboutButtonText,
    aboutTextDescription,
    aboutList,
    highlightButtonText,
    highlightButtonUrl,
    highlightisComingSoon,
    highlightExternalLink,
    highlightText,
    highlightImage,
  } = fields || {};

  // 创建数据对象
  const hero = {
    image: heroImage,
    text: getFieldValue(heroText),
  };

  const about = {
    durationValue: getFieldValue(aboutDurationValue),
    mileageValue: getFieldValue(aboutMileageValue),
    aboutDurationUnit: getFieldValue(aboutDurationUnit),
    aboutMileageUnit: getFieldValue(aboutMileageUnit),
    button: {
      buttonUrl: aboutButtonUrl?.value?.href || getFieldValue(aboutButtonUrl),
      buttonText: getFieldValue(aboutButtonText),
    },
    textDescription: getFieldValue(aboutTextDescription),
  };

  const list = aboutList || [];

  const highlight = {
    image: highlightImage,
    text: getFieldValue(highlightText),
    buttonText: getFieldValue(highlightButtonText),
    buttonUrl: highlightButtonUrl?.value?.href || getFieldValue(highlightButtonUrl),
    isComingSoon:
      highlightisComingSoon?.value !== undefined
        ? highlightisComingSoon?.value
        : highlightisComingSoon || false,
    externalLink:
      highlightExternalLink?.value !== undefined
        ? highlightExternalLink?.value
        : highlightExternalLink || false,
  };

  return (
    <div className="container">
      <HeroSection heroSectionData={hero} />
      <AboutSection aboutSectionData={about} />
      <ListSection listSectionData={list} />
      <HighlightSection highlightSectionData={highlight} />
    </div>
  );
};

export default WarrantyPage;
